export default __webpack_public_path__ + "static/mykyta-remeslov-4a4c600ac0eebea99f0a5fb6bddb6e32.png";